/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fee: NonNullable<unknown> }} Pricing_Creator_DescriptionInputs */

const en_pricing_creator_description = /** @type {(inputs: Pricing_Creator_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Growth subscribers running a steady business. Lower fees, higher limits. ${i?.fee}% platform fee.`)
};

const es_pricing_creator_description = /** @type {(inputs: Pricing_Creator_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Suscriptores en crecimiento que manejan un negocio estable. Tarifas más bajas, límites más altos. ${i?.fee}% de tarifa de plataforma.`)
};

const fr_pricing_creator_description = /** @type {(inputs: Pricing_Creator_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonnés en croissance gérant une activité stable. Frais réduits, limites plus élevées. ${i?.fee} % de frais de plateforme.`)
};

const de_pricing_creator_description = /** @type {(inputs: Pricing_Creator_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wachsende Abonnenten, die ein stabiles Geschäft betreiben. Niedrigere Gebühren, höhere Limits. ${i?.fee}% Plattformgebühr.`)
};

const id_pricing_creator_description = /** @type {(inputs: Pricing_Creator_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pelanggan berkembang yang menjalankan bisnis secara stabil. Biaya lebih rendah, batas lebih tinggi. Biaya platform ${i?.fee}%.`)
};

/** @type {(inputs: Pricing_Creator_DescriptionInputs) => LocalizedString} */
const ja_pricing_creator_description = en_pricing_creator_description;

/** @type {(inputs: Pricing_Creator_DescriptionInputs) => LocalizedString} */
const zh_pricing_creator_description = en_pricing_creator_description;

/** @type {(inputs: Pricing_Creator_DescriptionInputs) => LocalizedString} */
const ar_pricing_creator_description = en_pricing_creator_description;

/** @type {(inputs: Pricing_Creator_DescriptionInputs) => LocalizedString} */
const it_pricing_creator_description = en_pricing_creator_description;

/** @type {(inputs: Pricing_Creator_DescriptionInputs) => LocalizedString} */
const ru_pricing_creator_description = en_pricing_creator_description;

/** @type {(inputs: Pricing_Creator_DescriptionInputs) => LocalizedString} */
const pt_pricing_creator_description = en_pricing_creator_description;

/** @type {(inputs: Pricing_Creator_DescriptionInputs) => LocalizedString} */
const ko_pricing_creator_description = en_pricing_creator_description;

/**
* | output |
* | --- |
* | "Growth subscribers running a steady business. Lower fees, higher limits. {fee}% platform fee." |
*
* @param {Pricing_Creator_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_creator_description = /** @type {((inputs: Pricing_Creator_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Creator_DescriptionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_creator_description(inputs)
	if (locale === "es") return es_pricing_creator_description(inputs)
	if (locale === "fr") return fr_pricing_creator_description(inputs)
	if (locale === "de") return de_pricing_creator_description(inputs)
	if (locale === "ja") return ja_pricing_creator_description(inputs)
	if (locale === "zh") return zh_pricing_creator_description(inputs)
	if (locale === "ar") return ar_pricing_creator_description(inputs)
	if (locale === "id") return id_pricing_creator_description(inputs)
	if (locale === "it") return it_pricing_creator_description(inputs)
	if (locale === "ru") return ru_pricing_creator_description(inputs)
	if (locale === "pt") return pt_pricing_creator_description(inputs)
	return ko_pricing_creator_description(inputs)
});